import Cube from "../Models/Cube";
import AddCubeRequest from "../Requests/Cubes/AddCubeRequest";
import HttpService from "../Services/HttpService";
import UpdateCubeRequest from "../Requests/Cubes/UpdateCubeRequest";
import UpdateMaintenanceModeRequest from "../Requests/Cubes/UpdateMaintenanceModeRequest";
import AddTestGroupRequest from "../Requests/Cubes/AddTestGroupRequest";

class CubeRepository
{
  public cubes: Cube[] = [];

  public async load(): Promise<Cube[]>
  {
    const url = '/Cube';
    this.cubes = await HttpService.get<Cube[]>(url);
    return this.cubes;
  }

  public async add(cube: Cube): Promise<void>
  {
    const url = '/Cube';
    const request: AddCubeRequest = cube
    await HttpService.post<Cube>(url, request);
    await this.load();
  }

  public async update(cube: Cube): Promise<void>
  {
    const url = '/Cube';
    const request: UpdateCubeRequest = cube
    await HttpService.put<Cube>(url, request);
    await this.load();
  }

  public async delete(cube: Cube): Promise<void>
  {
    const url = `/Cube/${cube.id}`;
    await HttpService.delete<void>(url);
    await this.load();
  }

  public async maintenance(cube: Cube, maintenanceMode: boolean): Promise<void>
  {
    const url = `/Cube/Maintenance`;
    const request: UpdateMaintenanceModeRequest = {
      id: cube.id,
      maintenanceMode: maintenanceMode,
    };
    await HttpService.put<void>(url, request);

    await this.load();
  }

  public async testGroup(request: AddTestGroupRequest): Promise<void>
  {
    const url = `/QueueLine/TestGroup`;
    await HttpService.post<void>(url, request);

    await this.load();
  }

  public getById(id: string): Cube | undefined
  {
    return this.cubes
      .find((cube: Cube) => cube.id === id);
  }
}

export const cubeRepository = new CubeRepository();